import { core_v1_DataSourceSpec } from '@antimatterhq/asl-api-ts-v1';
import { Fieldset } from '@antimatterhq/ui/components/fieldset';

type OverrideLiquidColumns = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<core_v1_DataSourceSpec['silver']>['transform']
    >['presetOverrides']
  >['modifyTables']
>[number]['overrideLiquidColumns'];

export const ColumnClusteringReview = ({
  overrideLiquidColumns,
}: {
  overrideLiquidColumns: OverrideLiquidColumns;
}) => {
  if (!overrideLiquidColumns?.length) {
    return (
      <div>
        <Fieldset.Field>
          <Fieldset.Label>Default clustering</Fieldset.Label>
        </Fieldset.Field>
      </div>
    );
  }
  return (
    <div>
      <Fieldset.Field>
        <Fieldset.Label>Custom clustering</Fieldset.Label>
      </Fieldset.Field>
      <Fieldset.List>
        <Fieldset.Field>
          <Fieldset.Label>Columns:</Fieldset.Label>
          <Fieldset.Value data-testid="review-clustering-columns">
            {overrideLiquidColumns.join(', ')}
          </Fieldset.Value>
        </Fieldset.Field>
      </Fieldset.List>
    </div>
  );
};
